import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import Audit from "components/UnifiedProject/Audit/Audit";

import * as projectReducer from "containers/Project/reducer";
import * as viewReducer from "containers/View/reducer";

class AuditContainer extends React.Component {
  render() {
    return <Audit {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  return {
    updateDrilldownValue: (runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  let optimized = ownProps.optimized;
  if (!optimized || optimized.id !== id) {
    optimized = projectReducer.getOptimized(state, id);
  }

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || modelGroups.id !== id) {
    modelGroups = projectReducer.getModelGroups(state, id);
  }

  return {
    project: projectReducer.getProject(state, id),
    optimized: optimized,
    optimizer: projectReducer.getOptimizer(state, id),
    modelGroups: modelGroups,

    scenarios: projectReducer.getAllScenarios(state, id),

    blueprints: viewReducer.getBlueprints(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(AuditContainer);
